import React, { useState } from 'react';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LineChart as RechartsLineChart,
  Legend,
  Line,
} from 'recharts';
import { Colors } from '@inplayer-org/inplayer-ui';
import { map } from 'lodash';

// data
import { colors } from 'data/colors';

// utils
import { randomColor } from 'utils/helpers';
import formatNumber from 'utils/formatNumber';

// components
import CustomLineChartTooltip from 'pages/MerchantPages/Analytics/components/CustomLineChartTooltip';

export interface DataItem {
  name: string;
  [key: string]: any;
}

interface Props {
  data: Array<DataItem>;
  dataKey: string | undefined;
  dataKeyGroups?: Array<string>;
}
const LineChart: React.FC<Props> = ({ data, dataKey, dataKeyGroups }) => {
  const [activeLine, setActiveLine] = useState('');

  const onLegendClick = ({ dataKey: legendKey }: { dataKey: string }) => {
    if (legendKey === activeLine) {
      setActiveLine('');
    } else {
      setActiveLine(legendKey);
    }
  };
  return (
    <ResponsiveContainer width="100%" height={450}>
      <RechartsLineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis allowDuplicatedCategory={false} dataKey="name" padding={{ left: 30, right: 30 }} />
        <YAxis
          tickFormatter={(tick) => {
            return formatNumber(tick);
          }}
        />
        <Tooltip content={<CustomLineChartTooltip dataKey={dataKey} />} />
        <Legend wrapperStyle={{ cursor: 'pointer' }} onClick={onLegendClick} />
        {!dataKey ? (
          map(dataKeyGroups, (value, index) => (
            <Line
              key={value}
              connectNulls
              type="monotone"
              dataKey={value}
              stroke={colors[index] || randomColor()}
              activeDot={{ r: 8 }}
              strokeOpacity={activeLine === value || activeLine === '' ? 1 : 0}
            />
          ))
        ) : (
          <Line connectNulls type="monotone" dataKey={dataKey} stroke={Colors.green} activeDot={{ r: 8 }} />
        )}
      </RechartsLineChart>
    </ResponsiveContainer>
  );
};

export default LineChart;
